import type { ColorType, FontType } from './util/types'

export const baseColors = {
  grey2: '#F4F4F4',
  grey12: '#E0E0E0',
  grey7: '#D1D1D6',
  grey9: '#939598',
  grey8: '#707070',
  darkGrey: '#65666A',
  lightGrey: '#D9D9D9',
  lighterGrey: '#F5F5F5',
  grey6: '#4D4D4D',

  green: '#92C04F',

  blue: '#2978C2',
  blue1: '#0B549A',
  blue2: '#06437B',
  blue3: '#81AED8',

  white: '#FFFFFF',
  white1: '#F5F5F5',
  white2: '#E3E3E3',

  red: '#CD3529',
  red1: '#B22015',
  red2: '#8F1A10',
  red3: '#E1867F',
  red4: '#FFD4D4',

  black: '#000000',
  yellow: '#ffc107',
  yellow2: '#FBF0C7',
  yellow3: '#F3CB5A',
  traneCorporate: '#6401ff',

  // Consumer RTH Graph colors

  cool: '#6BBEEA',
  coolStage2: '#1F729D',
  heat: '#FC6C68',
  heatStage2: '#BC1C10',
  heatStage3: '#E68B02',
  heatAux: '#FF9DA6',
  heatAuxStage2: '#FC6C68',
  heatAuxStage3: '#BC1C10',
  hoverBox: '#F0F0F0',
  hoverBoxBackground: '#F0F0F0',
  chartBackground: '#F3F7F8',
}

export const colors: ColorType = {
  primary: baseColors.blue,
  lessIntensePrimary: baseColors.blue1,
  traneCorporate: baseColors.traneCorporate,
  text: baseColors.grey8,
  colorEmphasizedText: baseColors.black,
  lessColorEmphasizedText: baseColors.darkGrey,

  active: baseColors.blue,
  activeText: baseColors.white,
  screen: '#F6F6F6',
  contentScreen: '#FAFAFA',
  uiHeaderBackground: baseColors.white,
  uiHeaderBorder: baseColors.grey7,
  uiHeaderTitleText: baseColors.grey8,
  uiHeaderAction: baseColors.blue,
  uiTabBarBackground: baseColors.white,
  uiTabBarTopBorder: baseColors.lightGrey,
  uiTabBarBadgeText: baseColors.white,
  uiTabBarBadgeActiveText: baseColors.white,
  modalBackdrop: baseColors.grey8,
  modalContentBackground: '#F6F6F6',
  headerText: baseColors.black,
  neutral: {
    zero: baseColors.white,
    lightest: baseColors.grey2,
    lighter: baseColors.grey12,
    light: baseColors.grey7,
    default: baseColors.grey9,
    dark: baseColors.grey8,
    darker: baseColors.darkGrey,
    darkest: baseColors.grey6,
    one: baseColors.black,
  },

  attention: {
    good: baseColors.green,
    bad: baseColors.red,
    required: baseColors.red,
    hey: baseColors.yellow,
    lessIntenseHey: baseColors.yellow2,
    meh: baseColors.blue,
    text: baseColors.grey2,
    traneCorporate: baseColors.traneCorporate,
    default: baseColors.grey9,
  },

  hvac: {
    cool: baseColors.blue,
    heat: baseColors.red,
  },

  consumerRTH: {
    border: baseColors.lightGrey,
    divider: baseColors.lighterGrey,
    tableHeaderText: baseColors.grey6,
    tableText: baseColors.grey6,
    chartBackground: baseColors.chartBackground,
    paneBackground: baseColors.white,
    primaryText: baseColors.grey6,

    cool: baseColors.cool,
    coolStage2: baseColors.coolStage2,
    heat: baseColors.heat,
    heatStage2: baseColors.heatStage2,
    heatStage3: baseColors.heatStage3,
    heatAux: baseColors.heatAux,
    heatAuxStage2: baseColors.heatAuxStage2,
    heatAuxStage3: baseColors.heatAuxStage3,
    hoverBox: baseColors.hoverBox,
    hoverBoxBackground: baseColors.hoverBoxBackground,
  },

  linkText: baseColors.blue2,

  listItemValue: baseColors.grey9,
  listItemTopLine: baseColors.grey6,
  listItemBottomLine: baseColors.darkGrey,

  marquee: baseColors.grey8,

  cardBackground: baseColors.white,
  cardForeground: baseColors.grey6,
  cardBorderColor: baseColors.white,
  cardText: baseColors.grey6,
  cardListSeparator: baseColors.grey12,
  cardShadow: baseColors.grey8,
  cardIcon: baseColors.grey8,

  controlBackground: baseColors.grey7,
  controlForeground: baseColors.blue2,

  popupBackground: baseColors.white,
  popupBackdrop: baseColors.grey12 + 'EE',

  switchForeground: baseColors.grey7,

  sidebarListSeparator: baseColors.grey8,
  sidebarText: '#707070',
  sidebarIcon: '#767676',
  sidebarTabletBorder: baseColors.grey2,

  slider: {
    form: {
      trackColor: baseColors.blue,
      backgroundTrackColor: baseColors.grey2,
      thumbColor: baseColors.grey7,
      label: baseColors.grey6,
    },
    independent: {
      trackColor: baseColors.blue,
      backgroundTrackColor: baseColors.grey12,
      thumbColor: baseColors.blue,
      label: baseColors.grey6,
    },
  },
}

export const fonts: FontType = {
  defaultLight: 'inter, sans-serif',
  defaultMedium: 'inter, sans-serif',
  defaultSemibold: 'inter, sans-serif',
  defaultBold: 'inter, sans-serif',
  titleLight: 'inter, sans-serif',
  titleMedium: 'inter, sans-serif',
  titleSemibold: 'inter, sans-serif',
  titleBold: 'inter, sans-serif',
  defaultSize: 12,
}
